<div fxLayout="row" fxLayoutAlign="center center">
  <div fxFlex="100%" class="text-center">
    <mat-icon aria-hidden="false" aria-label="error icon">error</mat-icon>
    <div mat-dialog-title class="dialog-header">
      <button type="button" class="close-button" mat-dialog-close aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>

      <h4> Are you sure?</h4>
    </div>
    <div mat-dialog-content>
      <p>You will not be able to recover this once deleted!</p>
    </div>
    <div mat-dialog-actions fxLayout="row" fxLayoutAlign="center center">
      <button mat-raised-button mat-dialog-close>Cancel</button>
      <button mat-raised-button color="warn" [mat-dialog-close]="id">Yes, delete it!</button>
    </div>
  </div>
</div>
